import type { UserBudgeDetailList, UserBudgeList } from '@core/types/auto/actuator';
import type { IdNameOption } from '@core/types/common';
import type {
  CurrentLevelInfoVO,
  LevelRewardVO,
  MissionVO,
  RewardVO,
} from '@core/types/incentive';
import { httpService } from '../http';

/**
 * 获取当前声望和等级+当前等级最低值+最高值+下一等级的奖励
 */
export function getCurLevelInfo() {
  return httpService.get<CurrentLevelInfoVO>(
    `/api/code-community-actuator/api/user/level/getCurLevelInfo`,
  );
}

/**
 * 轮询是否有待领取任务奖励
 */
export function checkMission() {
  return httpService.get<boolean>(
    `/api/code-community-actuator/api/user/mission/can-receive`,
  );
}

/**
 * C端任务列表接口
 */
export function getMissionList() {
  return httpService.get<MissionVO[]>(
    `/api/code-community-actuator/api/user/mission/list`,
  );
}

/**
 * 领取任务奖励
 */
export function getReward(data: { userMissionId: number; ladderId?: number }) {
  return httpService.put(
    `/api/code-community-actuator/api/user/mission/get-reward`,
    {
      body: data,
    },
  );
}

/**
 * 抽取随机任务
 */
export function getRandomMission() {
  return httpService.post<MissionVO>(
    `/api/code-community-actuator/api/user/mission/draw-mission`,
  );
}

/**
 * 获取我的背包-已领取的任务奖励
 */
export function getMyBackpack() {
  return httpService.get<RewardVO[]>(
    `/api/code-community-actuator/api/user/backpack/my-backpack`,
  );
}

/**
 * 使用装备和卸下装备接口
 */
export function toggleEquip(data: { id: number; isEquip: boolean }) {
  return httpService.put(
    `/api/code-community-actuator/api/user/backpack/onoff-outfit`,
    {
      body: data,
    },
  );
}

/**
 * 查询各等级对应的奖励接口-不分页-一次性返回
 */
export function getAllLevelReward() {
  return httpService.get<LevelRewardVO[]>(
    `/api/code-community-actuator/api/level/reward`,
  );
}
/**
 * 查询随机任务池中的任务列表
 */
export function getRandomList() {
  return httpService.get<IdNameOption[]>(
    `/api/code-community-actuator/api/user/mission/random-list`,
  );
}

export function getUserBadgeList(uid: string) {
  return httpService.get<UserBudgeList>(
    `/api/code-community-actuator/api/user/backpack/user-badge-list`,
    { query: { uid } },
  );
}

export function getUserTabBadge(query: {
  tabId: number;
  uid: string;
  missionTime?: number;
}) {
  return httpService.get<UserBudgeDetailList>(
    `/api/code-community-actuator/api/user/backpack/user-tab-badge`,
    { query },
  );
}
